import classNames from 'classnames';
import { useCallback, useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';

import Alert from '../../components/core/Alert';

import { IAlertParams } from './types';

const useStyles = createUseStyles<string, { top?: string; position?: 'static' | 'fixed' }>(
  {
    container: {
      position: (props) => props.position || 'static',
      top: (props) => props.top,
      left: 0,
      right: 0,
    },
  },
  { name: 'alert-container' },
);

function useAlert({
  className,
  isVisible = false,
  top,
  position = 'static',
  ...restProps
}: IAlertParams) {
  const classes = useStyles({ top, position });
  const [visible, setVisible] = useState<boolean>(isVisible);

  const show = useCallback(() => {
    setVisible(true);
  }, []);

  const hide = useCallback(() => {
    setVisible(false);
  }, []);

  const element = useMemo(
    () =>
      visible ? (
        <div className={classNames(classes.container, className)}>
          <Alert {...restProps} onClose={hide} />
        </div>
      ) : null,
    [visible, classes.container, className, restProps, hide],
  );

  return [element, show, hide] as const;
}

export default useAlert;
